import * as React from "react";
const WaveIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 -2 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="wave" transform="translate(-2 -4)">
      <path
        id="primary"
        d="M21,11c-2.25,0-2.25,2-4.5,2s-2.25-2-4.5-2-2.25,2-4.5,2S5.25,11,3,11"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        id="primary-2"
        data-name="primary"
        d="M3,5C5.25,5,5.25,7,7.5,7S9.75,5,12,5s2.26,2,4.51,2S18.75,5,21,5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        id="primary-3"
        data-name="primary"
        d="M21,17c-2.25,0-2.25,2-4.5,2s-2.25-2-4.5-2-2.25,2-4.5,2S5.25,17,3,17"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </g>
  </svg>
);
export default WaveIcon;
